export default "__VITE_ASSET__DbLRYlQ3__"